import { CONST_LSTGRP_IMPLICIT } from "@app/state/constants";
import { IDBLxReportOption, ILxReportOption } from "@app/types/insider";

import type { TKarmaFs } from "@app/types/insider";
// Utility to parse JSON safely
const parseJSON = (jsonString: string) => {
  try {
    return JSON.parse(jsonString);
  } catch (e) {
    console.error("Failed to parse JSON:", e);
    return {};
  }
};

// Determines if an option should be read-only
const applyReadonly = (option: IDBLxReportOption, meAmaId: number): boolean => {
  if (option.READONLY || option.GROUP_DISPLAY_NAME === CONST_LSTGRP_IMPLICIT) {
    return true;
  }
  return option.OWNER_AMA !== meAmaId && Boolean(+option.READONLY);
};

// Converts blob state from string to JSON
const blobState = (blob: string) => parseJSON(blob);

// Maps DB list item type to a UI compatible format
export const mapListItem = (
  item: IDBLxReportOption,
  meAmaId: number
): ILxReportOption => {
  const { selectionOptions, ...blob } = blobState(item.B_GRIDSTATE);
  return {
    id: item.KLR_ID,
    group: item.KLR_GROUP,
    name: item.LIST_NAME,
    displayName: item.LIST_DISPLAY_NAME,
    displayGroup: item.GROUP_DISPLAY_NAME,
    text: item.TEXT,
    access: item.ACCESS,
    readonly: applyReadonly(item, meAmaId),
    ownerAma: item.OWNER_AMA,
    selectionOptions: selectionOptions || {},
    state: blob,
    params_default: {},
    params_mandatory: [],
    params_optional: [],
  };
};

// Processes an array of DB list items into a map of UI list items
export const processLoadLists = (
  data: IDBLxReportOption[],
  meAmaId: number
): Record<string, ILxReportOption> => {
  return data.reduce((acc, item) => {
    const listItem = mapListItem(item, meAmaId);
    acc[listItem.id] = listItem;
    return acc;
  }, {} as Record<string, ILxReportOption>);
};
